export const LoadingIndicator = () => {
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="flex flex-col items-center">
        <svg className="h-12 w-12 animate-spin" viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="#cbd5e0"
            strokeWidth="4"
            fill="none"
          />
          <path
            className="opacity-75"
            fill="#3b82f6"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        <p className="text-gray-700 mt-4 text-lg">Loading...</p>
      </div>
    </div>
  )
}
